export default __webpack_public_path__ + "static/media/digitalCurrency.a31e0b6f.svg";